// Libraries
import styled from 'styled-components'

// Components
import { Body } from 'heeds-ds'

export const Image = styled.img`
  padding: 3.2rem 2.4rem 5.6rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    min-height: 37.7rem;
  }
`

export const ModalContainer = styled.div`
  min-height: 58.2rem;
  padding: 2.4rem 0;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    min-height: 65.9rem;
    padding: 0 2.4rem;
    width: 60.2rem;
  }
`

export const ModalTop = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 3rem 1.6rem 1.6rem;
  position: relative;
  ::after {
    background-color: ${({ theme }) => theme.colors.icon.disabled};
    content: '';
    height: 1.5px;
    opacity: 0.3;
    position: absolute;
    top: 100%;
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 2.4rem 1.6rem 1.6rem;
  }
`

export const Text = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
}))``
